module.exports = __webpack_public_path__ + "static/media/TOB-temp.8b8d2c48.pdf";